module.exports = __webpack_public_path__ + "static/media/trainVideo1.aee8b15a.mp4";